export const API_URL =
  process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : "https://1765ff9a.glacierhosting.org";

export const WEBSITE_URL =
  process.env.REACT_APP_WEBSITE_URL || "https://xevonbot.xyz";

export const DISCORD_INVITE_URL =
  process.env.REACT_APP_DISCORD_INVITE_URL ||
  "https://discord.com/oauth2/authorize?client_id=1515030145855914144&permissions=8&integration_type=0&scope=bot+applications.commands";

export const SUPPORT_SERVER_URL =
  process.env.REACT_APP_SUPPORT_URL || "https://discord.gg/y6FSJUeKZ";

export const BOT_NAME = "Xevon";
export const LOGO_URL = "/logo.png";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Features", path: "/features" },
  { label: "Commands", path: "/commands" },
  { label: "Premium", path: "/premium" },
  { label: "Docs", path: "/docs" },
  { label: "Support", path: "/support" },
  { label: "Dashboard", path: "/dashboard" },
];
